import { createAction, props } from '@ngrx/store';
import { LogThExport } from 'src/app/conf/thermo';
import { DevicesThGroupsData, DevicesThGroupsV2Data, ThDeviceStatus } from 'src/app/model/api/data-rest';
import { Thermo, ThermoLog } from 'src/app/model/thermo';
import { User } from 'src/app/model/user';


export const getDevicesThList = createAction('GET_DEVICE_TH_LIST');
export const getDevicesThListSuccess = createAction('GET_DEVICE_TH_LIST_SUCCESS',
    props<{ thGroupsList: DevicesThGroupsData }>());
export const getDevicesThListFailed = createAction('GET_DEVICE_TH_LIST_FAILED', props<{ errorMessage: string }>());

export const getDevicesThListV2 = createAction('GET_DEVICE_TH_LIST_V2');
export const getDevicesThListV2Success = createAction('GET_DEVICE_TH_LIST_V2_SUCCESS',
    props<{ thGroupsListV2: DevicesThGroupsV2Data }>());
export const getDevicesThListV2Failed = createAction('GET_DEVICE_TH_LIST_V2_FAILED', props<{ errorMessage: string }>());

export const getDeviceThStatus = createAction('GET_DEVICE_TH_STATUS',
    props<{ keycode: string }>());
export const getDeviceThStatusSuccess = createAction('GET_DEVICE_TH_STATUS_SUCCESS',
    props<{ thDeviceStatus: ThDeviceStatus }>());
export const getDeviceThStatusFailed = createAction('GET_DEVICE_TH_STATUS_FAILED', props<{ errorMessage: string }>());

export const getLogThExportReset = createAction('GET_LOG_TH_EXPORT_RESET');
export const getLogThExport = createAction('GET_LOG_TH_EXPORT', props<{
    startDate: Date;
    endDate: Date;
    metrics?: string[];
}>());
export const getLogThExportSuccess = createAction('GET_LOG_TH_EXPORT_SUCCESS',
    props<{ logThExport: LogThExport }>());
export const getLogThExportFailed = createAction('GET_LOG_TH_EXPORT_FAILED', props<{ errorMessage: string }>());

// TH LOG
export const getThLog = createAction('GET_TH_LOG', props<{
    from?: Date,
    intervaltype?: string,
    location?: string
}>());
export const getThLogSuccess = createAction('GET_TH_LOG_SUCCESS',
    props<{ thermoLog: ThermoLog; }>());
export const getThLogFailed = createAction('GET_TH_LOG_FAILED', props<{ errorMessage: string }>());

export const getThermoDevice = createAction('GET_THERMO_DEVICE', props<{ keycode: string }>());
export const getThermoDeviceSuccess = createAction('GET_THERMO_DEVICE_SUCCESS', props<{ deviceThermo: Thermo }>());
export const getThermoDeviceFailed = createAction('GET_THERMO_DEVICE_FAILED', props<{ errorMessage: string }>());

export const updateThermo = createAction('UPDATE_THERMO', props<{
    thermo: Thermo;
}>());
export const updateThermoSuccess = createAction('UPDATE_THERMO_SUCCESS', props<{ message: string }>());
export const updateThermoFailed = createAction('UPDATE_THERMO_FAILED', props<{ errorMessage: string }>());

export const setGroupSiteAssociation = createAction('SET_GROUP_SITE_ASSOCIATION', props<{
    siteId: number, groupId: number
}>());
export const setGroupSiteAssociationSuccess = createAction('SET_GROUP_SITE_ASSOCIATION_SUCCESS', props<{ message: string }>());
export const setGroupSiteAssociationFailed = createAction('SET_GROUP_SITE_ASSOCIATION_FAILED', props<{ errorMessage: string }>());

export const getFinalUsersThGroup = createAction('GET_FINAL_USERS_THGROUP', props<{ thGroupId: number }>());
export const getFinalUsersThGroupSuccess = createAction('GET_FINAL_USERS_THGROUP_SUCCESS', props<{ finalUsers: User[] }>());
export const getFinalUsersThGroupFailed = createAction('GET_FINAL_USERS_THGROUP_FAILED', props<{ errorMessage: string }>());

export const removeShareThGroup = createAction('REMOVE_SHARE_THGROUP', props<{ groupId: number; userId: number }>());
export const removeShareThGroupSuccess = createAction('REMOVE_SHARE_THGROUP_SUCCESS', props<{ message: string}>());
export const removeShareThGroupFailed = createAction('REMOVE_SHARE_THGROUP_FAILED', props<{ errorMessage: string }>());

export const revokeShareInvitationThGroupReset = createAction('REVOKE_SHARE_INVITATION_THGROUP_RESET');
export const revokeShareInvitationThGroup = createAction('REVOKE_SHARE_INVITATION_THGROUP', props<{ token: string }>());
export const revokeShareInvitationThGroupSuccess = createAction('REVOKE_SHARE_INVITATION_THGROUP_SUCCESS', props<{ message: string}>());
export const revokeShareInvitationThGroupFailed = createAction('REVOKE_SHARE_INVITATION_THGROUP_FAILED', props<{ errorMessage: string }>());

export const openWebsocketThermo = createAction('OPEN_WEBSOCKET');
export const closeWebsocketThermo = createAction('CLOSE_WEBSOCKET');